import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

// T0 — Bouton copier-dans-le-presse-papier partagé.
export const CopyButton = ({ text, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const onCopy = () => {
    const value = typeof text === 'string' ? text : JSON.stringify(text, null, 2);
    try {
      navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[CopyButton] copie impossible:', e);
    }
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      title="Copier"
      className={`p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400 ${className}`}
    >
      {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
    </button>
  );
};

export default CopyButton;
